import { replacePlaceholder } from 'utils/commonFunctions';
import { feeds } from '..';
import { urlTemplates } from 'api/urls';

export const feedsApi = feeds.injectEndpoints({
  endpoints: (builder) => {
    return {
      config: builder.query({
        query: () => {
          return {
            url: urlTemplates.config,
            method: 'GET',
            addBuster: false
            // headers: {
            //   Authorization: null // Pass the token in the headers
            // }
          };
        }
      }),
      getTopRankingGuest: builder.query({
        query: ({ leaderboardType }) => {
          return {
            url: replacePlaceholder(urlTemplates.getTopRankingGuest, {
              leaderboardType: leaderboardType
            }),
            method: 'GET',
            addBuster: true
          };
        }
      }),
      getLeaderboardGuest: builder.query({
        query: ({ quizId, leaderboardType }) => {
          return {
            url: replacePlaceholder(urlTemplates.getLeaderboardGuest, {
              quizId,
              leaderboardType
            }),
            method: 'GET',
            addBuster: true
          };
        }
      })
    };
  }
});

export const { useConfigQuery, useGetTopRankingGuestQuery, useGetLeaderboardGuestQuery } = feedsApi;
